import clsx from 'clsx';
import { FC, ReactNode } from 'react';
import styles from './SectionTitle.module.scss';

export interface ISectionTitleProps {
  children: ReactNode;
  className?: string;
}

export const SectionTitle: FC<ISectionTitleProps> = (props) => {
  const { children, className } = props;

  return <div className={clsx(styles.SectionTitle, className)}>{children}</div>;
};
